import { useCallback, useMemo, useState } from 'react';

type TSortState<T extends string = string> = {
  sortingField: T;
  sortingReverse: boolean;
  toggleSort: (field: T) => void;
  orderBy: T;
  orderType: 'asc' | 'desc';
};

export const useSortState = <T extends string = string>(defaultField: T, defaultReverse = false): TSortState<T> => {
  const [sortingField, setSortingField] = useState<T>(defaultField);
  const [sortingReverse, setSortingReverse] = useState(defaultReverse);

  const toggleSort = useCallback(
    (field: T) => {
      if (sortingField !== field) {
        setSortingField(field);
        setSortingReverse(false);
      } else {
        setSortingReverse((prev) => !prev);
      }
    },
    [sortingField],
  );

  const orderBy = sortingField;
  const orderType = useMemo<'asc' | 'desc'>(() => (sortingReverse ? 'desc' : 'asc'), [sortingReverse]);

  return { sortingField, sortingReverse, toggleSort, orderBy, orderType };
};
